export default __webpack_public_path__ + "static/how_do_you_define_a_successful-cff07a2bd26aa4b00981d5439f895453.mp4";